import Initials from "./initials.js";
import Bloodhound from 'bloodhound-js';

export default class UserTokenizer {
  constructor() {
    const tokenizers = document.querySelectorAll(".user-tokenizer");
    const self = this;

    if (tokenizers.length) {
      tokenizers.forEach((tokenizer) => {
        self.initialize(tokenizer);
      });
    }
  }

  initialize(element) {
    const myInitials = new Initials();
    const permissions = document.querySelector('form.permissions');
    const users = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace("value"),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: element.dataset.url + "?q=%QUERY",
        wildcard: "%QUERY",
      },
    });

    if (permissions) {
      $(element).on("tokenfield:createdtoken", function (e) {
        // Über-simplistic e-mail validation
        var re1 = /\S+@\S+\.\S+/;
        var valid1 = re1.test(e.attrs.value);
        var re2 =
          /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/g;
        var valid2 = re2.test(e.attrs.value);
        if (!valid1 && !valid2) $(e.relatedTarget).addClass("invalid");
      }).typeahead({
        hint: true,
        highlight: true,
        showHintOnFocus: true
      },{
        source: users,
        display: 'label',
        templates: {
          empty: [
            '<div class="empty-message">',
            'No users found.',
            '</div>'
          ].join('\n'),
          suggestion: function(data) {
            var output = '<div>';
            var displayText = data.label;

            var photoUrl;
            if(data.avatar_url) {
              photoUrl = data.avatar_url;
              output += '<div><img class="tt-image rounded-circle default-avatar color-avatar" src="' + data.avatar_url + '"/>' + displayText + '</div>';
            }
            else {
              output += '<div class="d-flex align-items-center"><div class="tt-image default-avatar color-avatar rounded-circle d-flex align-items-center justify-content-center text-uppercase" style="background-color: ' + myInitials.initialsToColor(displayText) + ' ">' + displayText.slice(0,1) +'</div>' + displayText + '</div>';
            }

            return output;
          }
        }
      }).bind('typeahead:select', function(ev, suggestion) {
        //suggestion.value
        document.querySelector('#name').setAttribute('data-value', suggestion.value);
        this.checkValue;
      }).blur(this.checkValue);
    } else {
      $(element)
        .on("tokenfield:createdtoken", function (e) {
          // Über-simplistic e-mail validation
          var re1 = /\S+@\S+\.\S+/;
          var valid1 = re1.test(e.attrs.value);
          var re2 =
            /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/g;
          var valid2 = re2.test(e.attrs.value);
          if (!valid1 && !valid2) $(e.relatedTarget).addClass("invalid");
        })
        .tokenfield({
          showAutocompleteOnFocus: true,
          createTokensOnBlur: true,
          typeahead: [
            {
              hint: true,
              highlight: true,
              showHintOnFocus: true,
            },
            {
              limit: "Infinity",
              display: "label",
              source: users,
              templates: {
                empty: [
                  '<div class="empty-message">',
                  "No users found.",
                  "</div>",
                ].join("\n"),
                suggestion: function (data) {
                  var output = "<div>";
                  var displayText = data.label;

                  var photoUrl;
                  if (data.avatar_url) {
                    photoUrl = data.avatar_url;
                    output +=
                      '<div><img class="tt-image rounded-circle default-avatar color-avatar" src="' +
                      data.avatar_url +
                      '"/>' +
                      displayText +
                      "</div>";
                  } else {
                    output +=
                      '<div class="d-flex align-items-center"><div class="tt-image default-avatar color-avatar rounded-circle d-flex align-items-center justify-content-center text-uppercase" style="background-color: ' +
                      myInitials.initialsToColor(displayText) +
                      ' ">' +
                      displayText.slice(0, 1) +
                      "</div>" +
                      displayText +
                      "</div>";
                  }

                  return output;
                },
              },
            },
          ],
        })
      $('.tt-menu').css({'left': '-9px', 'max-height': '280px', 'overflow-y': 'auto'});
    }
    $('.twitter-typeahead').css('display', 'block');
    $('.tt-input').css('padding-left', '9px');
  }

  checkValue() {
    const invalidFeedback = document.querySelector('.invalid-feedback');
    invalidFeedback && ( invalidFeedback.style.display = 'none' );
    const hiddenId = document.querySelector('#hiddenId');
    document.querySelector('#hiddenId').value = document.querySelector('#name').getAttribute('data-value');
    if (!hiddenId.value) {
      document.querySelector('#feedback').style.display = 'block';
    }
  }
}
